var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-4"},[_c('v-alert',{attrs:{"dense":"","outlined":"","type":_vm.type}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }